/**
 * Pure pricing helpers for the Thrive by Madsen cart.
 * Kept in fils (1 AED = 100 fils) for backend parity.
 *
 * REVIVE bundle rules (per line-item container):
 *   1 box  = AED 160
 *   2 boxes = AED 300  (fixed bundle price — saves AED 20)
 *   3+ boxes = 10% off unit price × qty
 * Oryvita: flat AED 49.95 / kg (no bundle rule at this layer; "buy 4 get 1 free" is fulfilment-only)
 * Delivery: free at subtotal ≥ AED 200, else AED 15.
 */

export const REVIVE_UNIT = 160;
export const REVIVE_TWO_BOX = 300;
export const REVIVE_MULTI_DISCOUNT = 0.1;
export const ORYVITA_UNIT = 49.95;
export const FREE_SHIPPING_THRESHOLD = 200;
export const DELIVERY_FEE = 15;

export const reviveSubtotal = (totalBoxes) => {
  if (totalBoxes <= 0) return 0;
  if (totalBoxes === 1) return REVIVE_UNIT;
  if (totalBoxes === 2) return REVIVE_TWO_BOX;
  return +(REVIVE_UNIT * totalBoxes * (1 - REVIVE_MULTI_DISCOUNT)).toFixed(2);
};

export const reviveSavings = (totalBoxes) => {
  if (totalBoxes < 2) return 0;
  return +(REVIVE_UNIT * totalBoxes - reviveSubtotal(totalBoxes)).toFixed(2);
};

export const oryvitaSubtotal = (kg) => +(ORYVITA_UNIT * kg).toFixed(2);

export const computeCart = (reviveBoxes, oryvitaKg) => {
  const reviveSub = reviveSubtotal(reviveBoxes);
  const oryvitaSub = oryvitaSubtotal(oryvitaKg);
  const subtotal = +(reviveSub + oryvitaSub).toFixed(2);
  const delivery = subtotal >= FREE_SHIPPING_THRESHOLD ? 0 : DELIVERY_FEE;
  const total = +(subtotal + delivery).toFixed(2);
  return {
    reviveSubtotal: reviveSub,
    reviveSavings: reviveSavings(reviveBoxes),
    oryvitaSubtotal: oryvitaSub,
    subtotal,
    delivery,
    total,
    freeShipping: delivery === 0,
  };
};
